import { Component, Input } from '@angular/core';
import {
  getCountdownBackground,
  PAYMENT_FAILED_REDIRECT_COUNTDOWN_SECONDS,
} from 'src/app/shared/payment.helper';

/**
 * The payment-failed result layout: icon, title, subtitle and the redirect
 * countdown circle. The defaults are the payment failed page; the kiosk voucher
 * scan results (#11798) reuse the same layout with their own texts, the
 * thank-you page's success tick and a shorter or hidden countdown.
 */
@Component({
  selector: 'app-payment-failed-content',
  templateUrl: './payment-failed-content.component.html',
  styleUrls: ['./payment-failed-content.component.scss'],
})
export class PaymentFailedContentComponent {
  @Input() countdown: number;
  /** Total seconds the countdown started from; drives the ring. */
  @Input() countdownTotal = PAYMENT_FAILED_REDIRECT_COUNTDOWN_SECONDS;
  @Input() showCountdown = true;
  /** `success` shows the thank-you page's tick instead of the red icon. */
  @Input() variant: 'error' | 'success' = 'error';
  @Input() titleKey = 'public.standalonepayment.paymentFailed.paymentFailed';
  @Input() titleParams: Record<string, unknown> | null = null;
  @Input() subtitleKey = 'public.checkout.progress.error.redirectMessage';
  @Input() subtitleParams: Record<string, unknown> | null = null;

  /** The thank-you page's tick, cache-busted so the one-shot animation replays each time. */
  readonly successImageUrl = `assets/img/SuccessCheck.webp?t=${Date.now()}`;

  getCountdownBackground(remaining: number): string {
    return getCountdownBackground(remaining, this.countdownTotal);
  }
}
